import React, { useState, useCallback, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';

function index({ selectedDevice, handleClose, notification, refreshList }) {
  const orgId = JSON.parse(localStorage.user).organization.id;
  const { userId } = JSON.parse(localStorage.user).user;
  const formModel = {
    deviceId: selectedDevice,
    projectId: '',
    location: '',
    longitude: '',
    latitude: '',
    attributes: null,
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [attributes, setAttributes] = useState();
  const [state, getProject] = useApi();
  const [state2, getDevice] = useApi();
  const [state3, getZones] = useApi();
  const [projects, setProjects] = useState([]);
  const [device, setDevices] = useState([]);
  const [zones, setZones] = useState([]);
  const key = useRef(null);
  const value = useRef(null);
  const [type, setType] = useState(['UNIT', 'BOX', 'PALLET', 'CONTAINER']);

  useEffect(() => {
    getProject(`/organization/${orgId}/projects`, 'GET');
    getDevice(`/organization/${orgId}/devices`, 'GET');
    getZones(`/organization/${orgId}/zones`, 'GET');
  }, []);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setProjects(state.data.projects);
    }
  }, [state]);

  useEffect(() => {
    if (!state3.isLoading && !state3.isError && state3.data) {
      const zonesFiltered = state3.data.filter(zone => zone.location !== null);
      const _zones = zonesFiltered.sort((a, b) => (a.location.toLowerCase() > b.location.toLowerCase() ? 1 : -1));
      setZones(_zones);
    }
  }, [state3]);

  useEffect(() => {
    if (!state2.isLoading && !state2.isError && state2.data) {
      const deviceArray = state2.data.devices.filter((data) => {
        if (!data?.device?.isActive && !data?.isActive) {
          if (
            data?.deviceType === 'BLE_GW' ||
            data?.device?.deviceType === 'BLE_GW' ||
            data?.deviceType === 'PHONE_GW' ||
            data?.device?.deviceType === 'PHONE_GW'
          ) {
            return data;
          }
        }
      });
      setDevices(deviceArray);
    }
  }, [state2]);

  useEffect(() => { }, [formData]);

  const getId = (name) => {
    const project = projects.filter((item) => item.projectName === name);
    return project[0].id;
  };

  const getGatewayType = (name) => {
    const _device = device.filter((item) => item?.id === name || item?.device?.id === name);
    return _device[0].deviceType || _device[0].device.deviceType;
  };

  const handleInputChange = useCallback((e) => {
    if(e.target.name === 'location') {
      zones.forEach((zone) => {
        if(zone.location === e.target.value) {
          formData.latitude = zone.gateways[0].latitude;
          formData.longitude = zone.gateways[0].longitude
        }
      })
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    const body = {
      ...formData,
      // projectId: getId(formData.projectId),
      gatewayType: getGatewayType(formData.deviceId),
      attributes,
    };
    postData(`/device/${formData.deviceId}/gateway`, 'POST', body);
  };

  const handleAddAttributes = () => {
    const x = { ...attributes };
    const k = key.current.value;
    const v = value.current.value;

    x[k] = v;
    setAttributes(x);
  };

  const deleteAttribute = (item) => {
    const attr = { ...attributes };
    delete attr[item[0]];

    setAttributes(attr);
  };
  useEffect(() => {
    key.current.value = '';
    value.current.value = '';
  }, [attributes]);

  useEffect(() => { }, [attributes]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      notification('success', `Gateway provision successfully`);
      refreshList();
      handleClose();
    }
    if (isError) {
      notification('error', `Unable to provision Gateway`);
      handleClose();
    }
  }, [isLoading, isError, data]);

  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20 px-16"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-2/4 py-8 px-8 pl-12 relative mt-10 rounded-3xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-12 right-10 h-4 cursor-pointer"
          alt=""
          onClick={handleClose}
        />
        <p className="font-bold text-lg text-textBlue1">Provision Gateway</p>
        {/* <p className="font-bold text-lg text-textBlue1">CREATE GATEWAY</p> */}
        <form className="mt-8 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="company" className="block text-parameter w-1/3 text-sm">
              GATEWAY ID
            </label>
            <input
              type="text"
              value={formData.deviceId}
              autoComplete="off"
              name="deviceId"
              list="deviceId"
              className="rounded-lg bg-white px-4 py-1 focus:outline-none  text-secondary border w-1/2 h-8"
              onChange={handleInputChange}
            />
            <datalist id="deviceId">
              {device.map((item) => (
                <option key={item?.device ? item?.device?.id : item?.id}>
                  {item?.device ? item?.device?.id : item?.id}
                </option>
              ))}
            </datalist>
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              ZONE
            </label>
            <input
              type="text"
              value={formData.location}
              name="location"
              list="zones"
              autoComplete="off"
              className="rounded-lg bg-white px-4 py-1 focus:outline-none  text-secondary border w-1/2 h-8"
              onChange={handleInputChange}
              required
            />
            <datalist id="zones">
              {zones.map((item) => (
                <option key={item?.location}>
                  {item?.location}
                </option>
              ))}
            </datalist>
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              LATITUDE
            </label>
            <input
              type="text"
              value={formData.latitude}
              name="latitude"
              autoComplete="off"
              className="rounded-lg bg-white px-4 py-1 focus:outline-none  text-secondary border w-1/2 h-8"
              onChange={handleInputChange}
            />
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              LONGITUDE
            </label>
            <input
              type="text"
              value={formData.longitude}
              name="longitude"
              autoComplete="off"
              className="rounded-lg bg-white px-4 py-1 focus:outline-none  text-secondary border w-1/2 h-8"
              onChange={handleInputChange}
            />
          </div>
          <p className="font-black text-base my-3 w-full text-primary">ATTRIBUTES</p>

          <div className="relative flex w-full">
            <div className="flex w-1/2 items-center  my-3.5">
              <label htmlFor="website" className="block text-parameter w-1/3 text-sm mr-2">
                KEY
              </label>
              <input
                type="text"
                ref={key}
                className="rounded-lg bg-white px-4 py-1 focus:outline-none  text-secondary border w-1/2 h-8"
              />
            </div>

            <div className="flex w-1/2 items-center  my-3.5">
              <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
                VALUE
              </label>
              <input
                type="text"
                ref={value}
                className="rounded-lg bg-white px-4 py-1 focus:outline-none  text-secondary border w-1/2 h-8"
              />
            </div>

            <img
              src="assets/img/Add.svg"
              className="absolute right-1 h-7 top-4 cursor-pointer"
              alt=""
              onClick={handleAddAttributes}
            />
          </div>

          <div className="w-full flex">
            {attributes &&
              Object.entries(attributes).map((item) => (
                <p
                  className="text-black py-1 px-4 rounded-full border mx-2 cursor-pointer"
                  onClick={() => deleteAttribute(item)}
                >
                  {item.join(' - ')}
                </p>
              ))}
          </div>
          <div className="mt-1 w-3/4">
            {isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto bottom-0" alt="" />
            ) : (
              <input
                type="submit"
                className="rounded-lg focus:outline-none px-12 h-10 text-textBlue1 cursor-pointer float-right mr-20 "
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default index;
